import React, { useState } from "react";

import openIcon from "svg/open.svg";

import Modal from "common/modal";

const CutSheet = ({ image, productName }) => {
  const [isShowCutSheetImage, setIsShowCutSheetImage] = useState(false);

  const handleCutSheetModal = (isShow) => {
    setIsShowCutSheetImage(isShow);
  };
  return (
    <div className="floormap-card col-11 col-md-5 col-lg-4">
      <div className="floormap-card__heading-container align-items-center">
        <span className={`floormap-card__floor-name col-12`}>{productName}</span>
      </div>
      <div className="floormap-card__seperator" />
      <div className="floormap-card__body">
        <span className="open-icon" onClick={() => handleCutSheetModal(true)}>
          <img src={openIcon} alt="..." />
        </span>
        <img src={image} className="floormap-card__body__image" />
      </div>
      {isShowCutSheetImage && (
        <Modal
          title={`Cut Sheet - ${productName}`}
          handleSave={() => {}}
          handleCancel={() => handleCutSheetModal(false)}
          size={"lg"}
          sectionName={""}
          bodyClass={"view-cutsheet-modal"}
        >
          <>
            <img src={image} alt="..." className="col-12 px-1 px-md-2" />
          </>
        </Modal>
      )}
    </div>
  );
};

export default CutSheet;
